<mat-icon *ngIf="icon && !image">{{ icon }}</mat-icon>
<img *ngIf="icon && image" [src]="icon" />
